import { Grid } from 'components/ui';
import { IndexListItemHeader } from 'components/styles_components/list';
import { FormattedMessage } from 'react-intl';
import useMobile from 'hooks/use_mobile';

const ListHeader = () => {
  const isMobile = useMobile();

  if (isMobile) {
    return null;
  }

  return (
    <IndexListItemHeader>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: 3 }} textAlign="left">
          <FormattedMessage id="session_info.device" />
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="center">
          <FormattedMessage id="browser.name" />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <FormattedMessage id="ip" />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <FormattedMessage id="session_info.logged_in_at" />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <FormattedMessage id="actions" />
        </Grid>
      </Grid>
    </IndexListItemHeader>
  );
};

export default ListHeader;
